<template>
    <div
        class="deadline apprentice-simple-card"
        v-if="hasDeadlines">
        <div class="component-title">
            <h5 class="title">{{ $t('deadline.title' )}}</h5>
        </div>
        <b-alert
            class="deadline-alert"
            show
            variant="danger">
            <div class="title-wrapper">
                <div class="icon">
                    <i class="fad fa-alarm-exclamation icon"></i>
                </div>
                <design-2021-apprentice-display-html-component
                    class="title"
                    :html-content="getDeadlineText()">
                </design-2021-apprentice-display-html-component>
            </div>
            <b-button
                class="btn-show-all btn-show-deadline-details"
                variant="link-type"
                @click="showDeadlines"
                >meer
            </b-button>

            <design-2021-assignment-show-deadline-details-modal-component
                :deadlines="deadlines"></design-2021-assignment-show-deadline-details-modal-component>
        </b-alert>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    name: 'design-2021-assignment-show-deadline-component',
    props: {
        assignmentIn: Object,
    },
    data() {
        return {
            recentDeadline: null,
            days: null,
            assignment: this.assignmentIn,
            deadlineList: [],
        };
    },
    computed: {
        hasDeadlines() {
            if (this.assignmentIn.hasDeadline()) {
                return true;
            }

            for (const subAssignment of this.assignmentIn.sub_assignments) {
                if (subAssignment.hasDeadline()) {
                    return true;
                }
            }

            return false;
        },

        deadlines() {
            let deadlines = [];

            for (const subAssignmentDeadline of this.assignment.sub_assignments) {
                if (subAssignmentDeadline.hasDeadline()) {
                    this.deadlineList.push({
                        name: subAssignmentDeadline.name,
                        type: 'sub-assignment',
                        id: subAssignmentDeadline.id,
                        order: subAssignmentDeadline.order,
                        deadline: subAssignmentDeadline.deadlines[0].agenda_item?.date_time,
                    });
                }
            }

            if (this.assignment.hasDeadline()) {
                this.deadlineList.unshift({
                    name: this.assignment.name,
                    type: 'assignment',
                    id: this.assignment.id,
                    order: 0,
                    deadline: this.assignment.deadlines[0].agenda_item?.date_time,
                });
            }

            if (this.deadlineList.length) {
                deadlines = this.deadlineList.filter((assignmentDeadline) => {
                    return parseInt(moment(assignmentDeadline.deadline).diff(moment(), 'days')) >= 0;
                });

                deadlines.sort((a, b) => (a.deadline > b.deadline ? 1 : -1));
                this.days = deadlines.length > 0 && parseInt(moment(deadlines[0].deadline).diff(moment(), 'days'));
            }

            return this.deadlineList;
        },
    },

    methods: {
        showDeadlines() {
            this.$bvModal.show('assignment-show-deadline-detail-modal');
        },

        getDeadlineText() {
            if (this.days < 0) {
                return this.$t('assignment.all_deadlines_have_expired');
            }

            if (this.deadlines.length > 1) {
                return this.$tc('assignment.days_left_until_next_deadline', this.days);
            } else {
                return this.$tc('assignment.days_left_until_deadline', this.days);
            }
        },
    },

    watch: {
        assignmentIn: function (value) {
            this.assignment = value;
        },
    },
};
</script>

<style scoped lang="scss">
.deadline {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.deadline-alert {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 0;
    font-size: 1.3125rem;
    flex-wrap: wrap;
    border: none;
    background-color: transparent;
    padding: 0;

    .title-wrapper {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .title {
        margin-bottom: 0;
        line-height: 1;
        font-size: $base-font-size;
    }

    .icon {
        color: $danger;
        margin-right: map-get($grid-gutter-spacing, 'eight');
        font-size: 1.3125rem;

        i {
            margin-right: 0;
        }
    }

    .btn-show-deadline-details {
        flex: 1 0 100%;
        justify-content: flex-end;
        margin-top: map-get($grid-gutter-spacing, 'eight');
    }
}
</style>
